import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// In production, silence debug logging so it doesn't ship to guests or cost
// runtime work on every menu load. Real errors/warnings are kept.
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);